import { createStore, applyMiddleware, compose } from 'redux';
import rootSaga from '../sagas';
import createSagaMiddleware from 'redux-saga';

import { routerMiddleware } from 'react-router-redux';
import reducer from '../reducers';

export default function configureStore(history, initialState) {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [routerMiddleware(history), sagaMiddleware];
    let finalCreateStore;
    if(__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
        const DevTools = require('../containers/DevTools');
        finalCreateStore = compose(
            applyMiddleware(...middlewares)
            // window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(),
        )(createStore);
    } else {
        finalCreateStore = applyMiddleware(...middlewares)(createStore);
    }

    const store = finalCreateStore(reducer, initialState);
    sagaMiddleware.run(rootSaga, store.dispatch);

    /*if(__DEVELOPMENT__ && module.hot) {
        module.hot.accept('../reducers/index', () => {
            store.replaceReducer(reducer);
        });
    }*/

    return store;
}


// WEBPACK FOOTER //
// ./src/store/index.js